const _ = {
  byDifficulty: (a,b) => (a.difficulty > b.difficulty) ? 1 : ((b.difficulty > a.difficulty) ? -1 : 0),
  byTitle: (a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0),
  byName: (a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0),
  bySymbol: (a,b) => (a.symbol > b.symbol) ? 1 : ((b.symbol > a.symbol) ? -1 : 0),
  byLang: (a,b) => (a.lang > b.lang) ? 1 : ((b.lang > a.lang) ? -1 : 0),
  byTimestamp: (a,b) => (a.timestamp > b.timestamp) ? -1 : ((b.timestamp > a.timestamp) ? 1 : 0),
  byTimestampDesc: (a,b) => (a.timestamp > b.timestamp) ? 1 : ((b.timestamp > a.timestamp) ? -1 : 0),
  byRSINew: (a,b) => (a.rsiNew > b.rsiNew) ? -1 : ((b.rsiNew > a.rsiNew) ? 1 : 0),
  
  byRSI: (a,b) => (a.rsi > b.rsi) ? -1 : ((b.rsi > a.rsi) ? 1 : 0),
  byRSIDesc: (a,b) => (a.rsi > b.rsi) ? 1 : ((b.rsi > a.rsi) ? -1 : 0),

  byRSI_1d: (a,b) => (a.rsi_1d > b.rsi_1d) ? -1 : ((b.rsi_1d > a.rsi_1d) ? 1 : 0),
  byRSI_1D_Desc: (a,b) => (a.rsi_1d > b.rsi_1d) ? 1 : ((b.rsi_1d > a.rsi_1d) ? -1 : 0),

  by1h: (a,b) => (a.change_1h > b.change_1h) ? -1 : ((b.change_1h > a.change_1h) ? 1 : 0),
  by1hDesc: (a,b) => (a.change_1h > b.change_1h) ? 1 : ((b.change_1h > a.change_1h) ? -1 : 0),

  by7d: (a,b) => (a.change_7d > b.change_7d) ? -1 : ((b.change_7d > a.change_7d) ? 1 : 0),
  by7dDesc: (a,b) => (a.change_7d > b.change_7d) ? 1 : ((b.change_7d > a.change_7d) ? -1 : 0),

  by30d: (a,b) => (a.change_30d > b.change_30d) ? -1 : ((b.change_30d > a.change_30d) ? 1 : 0),
  by30dDesc: (a,b) => (a.change_30d > b.change_30d) ? 1 : ((b.change_30d > a.change_30d) ? -1 : 0),

  by24h: (a,b) => (a.change_24h > b.change_24h) ? -1 : ((b.change_24h > a.change_24h) ? 1 : 0),
  by24hDesc: (a,b) => (a.change_24h > b.change_24h) ? 1 : ((b.change_24h > a.change_24h) ? -1 : 0),
  
  byRank: (a,b) => (a.rank > b.rank) ? -1 : ((b.rank > a.rank) ? 1 : 0),
  byRankDesc: (a,b) => (a.rank > b.rank) ? 1 : ((b.rank > a.rank) ? -1 : 0),
  
  random: (items) => items[Math.floor(Math.random() * items.length)],
  shuffle: (items) => {
    for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  }
}

export default _;
